// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.drug.DrugSearchRequest */
/* istanbul ignore next */
@GandalfModel
export class DrugSearchRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Query is required' } })
	@GandalfValidator({ sizeString: { fieldLabel: 'Search', maxLength: 1000, minLength: 3, message: 'Search must be between 3 and 1000 characters' } })
	@GandalfProperty({ designType: String, isRequired: true })
	query!: string;

}
